import React, { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import TechnologyTab from '../../components/TechnologyTab'
import Navbar from '../../components/Navbar'
import deployment_1 from "../../assets/images/contents/deployment-1.png"
import deployment_2 from "../../assets/images/contents/deployment-2.png"
import Footer from '../../components/Footer'
import IndustriesImageContainer from '../../components/IndustriesImageContainer'
import { PrimaryButton } from '../../components/StyledButtons'
import { useSelector } from 'react-redux'
import { selectLanguage } from '../../redux/language/selector'
import filter_color from "../../assets/images/design/colorFilter.svg"
import ModalContactDiscussionForm from '../../components/ModalContactDiscussionForm'

const DeploymentOptions = () => {
    const { t } = useTranslation()

    const language = useSelector(selectLanguage)

    const [modalDiscussionOpen, setModalDiscussionOpen] = useState(false);
    const modalDiscussionRef = useRef(null);
    const handleOverlayClick = (event) => {
        if (modalDiscussionRef.current && !modalDiscussionRef.current.contains(event.target)) {
            setModalDiscussionOpen(false)
        }
    };
    document.onkeydown = function (evt) {
        if (evt.code === 'Escape') {
            setModalDiscussionOpen(false)
        }
    };

    return (
        <div className='deployment bg-primary'>
            <div className='color-filter-right' style={{ top: "45%" }}>
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <div className='color-filter-left' style={{ top: "60%" }} >
                <img src={filter_color} alt="" className='img-responsive' />
            </div>
            <Navbar />
            <div className='container-fluid deployment-header'>
                <div className='container pt-50 pt-md-150'>
                    <div className='col-md-7 col-sm-12 px-md-0 pt-lg-100 pt-50'>
                        <p className='font-64 font-weight-semi-bold header-title'>{t('deployment.header')}</p>
                    </div>
                    <div className='col-md-5 col-sm-12'>
                        <img src={deployment_1} alt="overview_1" className='img-responsive' />
                    </div>
                </div>
            </div>
            <TechnologyTab deploymentOptionsActive={true} />
            <div className='container'>
                <div className='flex justify-center'>
                    <div className='technology-chip'>
                        <p className='text-center header-title font-40 uppercase'>{t('technology-tab.deployment-options')}</p>
                    </div>
                </div>
                <div className='col-md-6 col-md-offset-3 pt-30'>
                    <p className='text-white text-center'>
                        {t('deployment.sub-title')}
                    </p>
                </div>
            </div>

            <div className='container pt-50'>
                <div className='deployment-content col-sm-12'>
                    <div className='col-lg-6'>
                        <p className='font-weight-semi-bold text-white font-32'>{t('deployment.title-1')}</p>
                        <p className='text-white pt-30'>{t('deployment.content-1')}</p>
                        {language === "en"
                            ?
                            <ul className='list-unstyled pt-20'>
                                <li className="checked-line"><span className='font-weight-semi-bold'>On-premise Software:</span> Qrypto’s robust and intelligent software is run in-house, on your servers in your own data centers or on your cloud</li>
                                <li className="checked-line mt-10"><span className='font-weight-semi-bold'>Qrypto Cloud:</span> Your applications make API calls to Qrypto’s highly secure cloud infrastructure</li>
                                <li className="checked-line mt-10"><span className='font-weight-semi-bold'>Hybrid:</span> You can choose to run select components in-house and take advantage of the Qrypto Cloud for the rest</li>
                            </ul>
                            :
                            <ul className='list-unstyled pt-10'>
                                <li className="checked-line"><span className='font-weight-semi-bold'>Phần mềm tại chỗ:</span> Phần mềm thông minh và mạnh mẽ của Qrypto được chạy nội bộ, trên máy chủ của bạn trong trung tâm dữ liệu của riêng bạn hoặc trên đám mây của bạn</li>
                                <li className="checked-line mt-10"><span className='font-weight-semi-bold'>Đám mây Qrypto:</span> Ứng dụng của bạn thực hiện lệnh gọi API tới cơ sở hạ tầng đám mây có độ bảo mật cao của Qrypto</li>
                                <li className="checked-line mt-10"><span className='font-weight-semi-bold'>Hỗn hợp:</span> Bạn có thể chọn chạy các thành phần chọn lọc nội bộ và tận dụng Đám mây Qrypto cho phần còn lại</li>
                            </ul>
                        }
                    </div>
                    <div className='col-lg-6'>
                        <div className='flex justify-center'>
                            <img src={deployment_2} alt="deployment-2" className='img-responsive' style={{ width: "420px" }} />
                        </div>
                    </div>

                    <div className='col-sm-12 mt-30'>
                        {language === "en"
                            ?
                            <table>
                                <thead>
                                    <tr className=''>
                                        <th><p className='font-weight-semi-bold'>Product</p></th>
                                        <th><p className='font-weight-semi-bold'>Cloud Options</p></th>
                                        <th>
                                            <p className='font-weight-semi-bold'>On-Premise</p>
                                            <p className='font-14'>in customer data-center or cloud</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <p className='eng-data'>Qrypto Generator</p>
                                            <p className='font-12 eng-data' >Generate digitally signed Qrypto Secure QR Codes</p>
                                            <p className='font-12 italic eng-data' >Code revocation and chaining API is included</p>
                                        </td>
                                        <td><p >Qrypto Cloud</p></td>
                                        <td>
                                            <p >Windows 64-bit</p>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Qrypto Validation Server</p>
                                            <p className='font-12'>Validate digitally signed Qrypto Secure QR Codes programmatically (API based)</p>
                                        </td>
                                        <td><p>Qrypto Cloud</p></td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>ADR Object Store</p>
                                            <p className='font-12'>For EDC, code-chaining & revocation</p>
                                        </td>
                                        <td>
                                            <p>AWS S3</p>
                                            <p className='italic font-12'>(customer’s account)</p>
                                        </td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>ADR Reverse Proxy</p>
                                            <p className='font-12'>For front-ending ADR Object Store in the DMZ</p>
                                        </td>
                                        <td><p>N.A.</p></td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            :
                            //VIETNAM
                            <table>
                                <thead>
                                    <tr className=''>
                                        <th><p className='font-weight-semi-bold'>Sản phẩm</p></th>
                                        <th><p className='font-weight-semi-bold'>Tùy chọn đám mây</p></th>
                                        <th>
                                            <p className='font-weight-semi-bold'>Tại chỗ</p>
                                            <p className='font-14'>trong trung tâm dữ liệu khách hàng hoặc đám mây</p>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <p className='eng-data'>Tạo Qrypto</p>
                                            <p className='font-12 eng-data' >Tạo mã QR bảo mật Qrypto được ký điện tử</p>
                                            <p className='font-12 italic eng-data' >API thu hồi mã và chuỗi được bao gồm</p>
                                        </td>
                                        <td><p >Đám mây Qrypto</p></td>
                                        <td>
                                            <p >Windows 64-bit</p>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Máy chủ xác thực Qrypto</p>
                                            <p className='font-12'>Xác thực mã QR bảo mật Qrypto được ký điện tử theo chương trình (dựa trên API)</p>
                                        </td>
                                        <td><p>Đám mây Qrypto</p></td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Cửa hàng đối tượng ADR</p>
                                            <p className='font-12'>Đối với EDC, chuỗi mã và thu hồi</p>
                                        </td>
                                        <td>
                                            <p>AWS S3</p>
                                            <p className='italic font-12'>(tài khoản của khách hàng)</p>
                                        </td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <p>Proxy ngược ADR</p>
                                            <p className='font-12'>Dành cho kho lưu trữ đối tượng ADR ngoại vi trong DMZ</p>
                                        </td>
                                        <td><p>N.A.</p></td>
                                        <td>
                                            <p>Linux 64-bit<sup>1</sup></p>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>}
                    </div>



                    <div className='col-sm-12 pt-30'>
                        <p className='text-white'>{t('deployment.content-2')}</p>
                        <ul className='list-unstyled'>
                            <li className="checked-line">{t('deployment.content-2-1')}</li>
                            <li className="checked-line">{t('deployment.content-2-2')}</li>
                            <li className="checked-line">{t('deployment.content-2-3')}</li>
                            <li className="checked-line">{t('deployment.content-2-4')}</li>
                        </ul>
                        {language === "en"
                            ?
                            <p className='text-white pt-30 pb-30'><span className='font-weight-semi-bold'>Contact us</span> to schedule a no-obligation discussion. We will help you determine the best deployment option for your use case.</p>
                            :
                            <p className='text-white pt-30 pb-30'><span className='font-weight-semi-bold'>Liên hệ với chúng tôi</span> để lên lịch một cuộc thảo luận không có nghĩa vụ. Chúng tôi sẽ giúp bạn xác định tùy chọn triển khai tốt nhất cho trường hợp sử dụng của bạn.</p>
                        }
                        <PrimaryButton
                        onClick={() => setModalDiscussionOpen(true)}
                        >{t("button.schedule-discussion")}</PrimaryButton>
                    </div>
                </div>
            </div>



            <div className='container'>
                <IndustriesImageContainer />
            </div>
            <Footer />
            {modalDiscussionOpen && <ModalContactDiscussionForm
                setOpenModal={setModalDiscussionOpen}
                handleOverlayClick={handleOverlayClick}
                modalRef={modalDiscussionRef} />}
        </div>
    )
}

export default DeploymentOptions